var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"white google-font"},[_c('v-container',{staticClass:"grey lighten-4",attrs:{"fluid":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","row":""}},[_c('v-flex',{attrs:{"xs12":"","md8":"","xl6":""}},[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }